module.exports = __webpack_public_path__ + "img/ic_cast.886ce71f.svg";